import * as angular from 'angular';

import * as React from 'react';
import { createRoot } from 'react-dom/client';

import PDFComponent from './appointment_pdf_component';

angular.module('bb.external').component('bbViewReports', {
  bindings: {},
  controller: DownloadPDFCtrl,
  controllerAs: 'vm',
  template: "<div id='content'></div>",
});

DownloadPDFCtrl.$inject = ['$location'];

function DownloadPDFCtrl($location) {
  const container = document.getElementById('content');
  if (!container) return;
  this.reactRoot = this.reactRoot || createRoot(container);
  this.reactRoot.render(
    <PDFComponent reportId={$location.search().reportId} />,
  );
}
